import { render, staticRenderFns } from "./CreateCost.vue?vue&type=template&id=f12f2d00"
import script from "./CreateCost.vue?vue&type=script&lang=js"
export * from "./CreateCost.vue?vue&type=script&lang=js"
import style0 from "./CreateCost.vue?vue&type=style&index=0&id=f12f2d00&prod&lang=css"
import style1 from "./CreateCost.vue?vue&type=style&index=1&id=f12f2d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports